import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles, ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import EditNoteIcon from '@mui/icons-material/EditNote';
import TaskIcon from '@mui/icons-material/Task';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTheme, ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from "@mui/material/styles";
import MenuIcon from '@mui/icons-material/Menu';
import DashboardIcon from '@mui/icons-material/Dashboard';

import IconButton from '@material-ui/core/IconButton';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, useMediaQuery } from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import SettingsIcon from '@mui/icons-material/Settings';
import { Timeline } from 'rsuite';
import CreditCardIcon from '@rsuite/icons/legacy/CreditCard';
import PlaneIcon from '@rsuite/icons/legacy/Plane';
import TruckIcon from '@rsuite/icons/legacy/Truck';
import UserIcon from '@rsuite/icons/legacy/User';
import CheckIcon from '@rsuite/icons/legacy/Check';
import './Timeline.css';
import EditIcon from '@mui/icons-material/Edit';

import {
    MaterialReactTable,

} from 'material-react-table';
import Skeleton from '@material-ui/lab/Skeleton';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

import {
    Box,
    Tooltip
} from '@mui/material';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import api from '../../../../../../services/api';
import MenuRecursosAdministrativos from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";

import Rodape from '../../../../../../components/Rodape';

import { Button, MenuItem, Select, InputLabel } from "@material-ui/core";
import Pagination from '@material-ui/lab/Pagination';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { styled } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import TextField from '@material-ui/core/TextField';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const drawerWidth = 240;



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .cabecalho_transparente': {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            color: 'rgba(0, 0, 0, 0)',
        },
        '& .cabecalho_azul': {
            backgroundColor: 'rgba(0, 0, 255, 1)',
            color: 'white',
        },
        '& .cabecalho_verde': {
            backgroundColor: 'rgba(0, 100, 0, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_claro': {
            backgroundColor: 'rgba(107,142,35, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_claro': {
            backgroundColor: 'rgba(184,134,11, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_cyan': {
            backgroundColor: 'rgba(0,139,139, 1)',
            color: 'white',
        },
        '& .cabecalho_verde_dark_sea': {
            backgroundColor: 'rgba(60,179,113, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_escuro': {
            backgroundColor: 'rgba(139,69,19, 1)',
            color: 'white',
        },
        '& .cabecalho_marrom_chocolate': {
            backgroundColor: 'rgba(210,105,30, 1)',
            color: 'white',
        },
        '& .cabecalho_darkslate': {
            backgroundColor: 'rgba(47,79,79, 1)',
            color: 'white',
        },
        '& .super-app.negative': {
            backgroundColor: 'rgba(157, 255, 118, 0.49)',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.positive': {
            backgroundColor: '#d47483',
            color: '#1a3e72',
            fontWeight: '600',
        },
        '& .super-app.neutro': {
            backgroundColor: '#363636',
            color: 'white',
            fontWeight: '600',
        },
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
    table: {
        minWidth: 650,
    },
}));

const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));

function novo() {
    window.location.href = "/gestao/operacional/almoxarifado/saidaestoque/cadastrarsaidaestoque"

}

export default function SaidaEstoque() {
    const [value, setValue] = useState(1);
    const [tableHeight, setTableHeight] = useState(400);

    const checkDarkMode = () => {
        const dMode = Cookies.get('darkMode');
        const dTema = Cookies.get('tema');
        if (dMode !== undefined) {
            return dMode === 'true';
        } else if (dTema !== undefined) {
            return dTema === 'dark';
        }
        return false;
    };

    const [darkMode, setDarkMode] = useState(checkDarkMode());

    useEffect(() => {
        const interval = setInterval(() => {
            const isDark = checkDarkMode();
            if (isDark !== darkMode) {
                setDarkMode(isDark);
            }
        }, 1000); // Check every second

        const handleFocus = () => {
            setDarkMode(checkDarkMode());
        };

        window.addEventListener('focus', handleFocus);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', handleFocus);
        };
    }, [darkMode]);

    const themeHelper = useMemo(() => ({
        bg: darkMode ? '#121212' : '#ffffff',
        paper: darkMode ? '#1e1e1e' : '#ffffff',
        text: darkMode ? '#ffffff' : '#000000',
        textSecondary: darkMode ? '#aaaaaa' : '#666666',
        border: darkMode ? '#333333' : '#e0e0e0',
        primary: darkMode ? '#bb86fc' : '#1976d2',
        secondary: darkMode ? '#03dac6' : '#dc004e',
        tableHeadBg: darkMode ? '#2d2d2d' : '#f5f5f5',
        tableRowEven: darkMode ? '#1a1a1a' : '#f9f9f9',
        tableRowOdd: darkMode ? '#242424' : '#e0e0e0',
        tableRowHover: darkMode ? '#333333' : '#d0f0ff',
    }), [darkMode]);

    // Create MUI v4 and v5 themes
    const coreTheme = useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            secondary: { main: themeHelper.secondary },
            background: { default: themeHelper.bg, paper: themeHelper.paper },
            text: { primary: themeHelper.text, secondary: themeHelper.textSecondary },
        },
        overrides: {
            MuiTextField: {
                root: darkMode ? {
                    '& label.Mui-focused': { color: 'white' },
                    '& label': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: 'white' },
                        '&.Mui-focused fieldset': { borderColor: 'white' },
                    }
                } : {}
            },
            MuiFormLabel: {
                root: darkMode ? { color: 'white', '&$focused': { color: 'white' } } : {}
            },
            MuiInputBase: {
                input: darkMode ? { color: 'white' } : {}
            }
        }
    }), [darkMode, themeHelper]);

    const muiTheme = useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            secondary: { main: themeHelper.secondary },
            background: { default: themeHelper.bg, paper: themeHelper.paper },
            text: { primary: themeHelper.text, secondary: themeHelper.textSecondary },
        },
        components: {
            MuiTextField: {
                styleOverrides: {
                    root: darkMode ? {
                        '& label.Mui-focused': { color: 'white' },
                        '& label': { color: 'white' },
                        '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                        '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                        '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                        '& .MuiInputBase-input': { color: 'white' },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: 'white' },
                            '&:hover fieldset': { borderColor: 'white' },
                            '&.Mui-focused fieldset': { borderColor: 'white' },
                        }
                    } : {}
                }
            }
        }
    }), [darkMode, themeHelper]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [open, setOpen] = useState(false);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const regra = Cookies.get("regra") || "";



    const handleMenuClick = (newValue) => {
        if (newValue === 0) {

        } else if (newValue === 1) {

            listar();
        } else if (newValue === 2) {


        }
        setValue(newValue);
    };



    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [height, setHeight] = useState(0);

    const [objetos, setObjetos] = useState(null);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 100,
    });

    const [totalRegistros, setTotalRegistros] = useState(0);


    function formatDate(date) {
        // Formate a data para 'HH:mm DD/MMM/YYYY'
        return moment(date).format('HH:mm DD/MM/YYYY');
    }



    function checkDimenssoes() {

        var altura = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;


        setHeight(altura * 0.75);

    }

    window.addEventListener('resize', function (event) {
        checkDimenssoes();
    });





    async function listar() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/almoxarifado/saidaestoque/listartodos", {
                headers: headers
            }).then(function (response) {

                setObjetos(response.data);
                //setTotalRegistros(response.data.total);

                setLoading(false);


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }


    useEffect(() => {


        checkDimenssoes();


        listar();


    }, []);






    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    function returnDescricaoFornecedor(fornecedor) {
        var texto = "Fornecedor_ID: " + fornecedor.id_fornecedor + "\nCPF/CNPJ: " + (fornecedor.tipo_fornecedor === 0 ? fornecedor.cpf : fornecedor.cnpj) +
            "\nNome/Nome Fantasia: " + (fornecedor.tipo_fornecedor === 0 ? (fornecedor.nome + " " + fornecedor.sobrenome) : fornecedor.nome_fantasia);

        return texto;
    }





    const handleClickEdicao = (row) => {


        window.location.href = "/gestao/operacional/almoxarifado/saidaestoque/gerenciarsaidaestoque/" + row.id_saida_estoque;


    };


    const STATUS_TEXT = {

        0: "Editando",
        1: "Aguardando Autorização",
        2: "Autorizado, Aguardando Baixa",
        3: "Baixado | Finalizado"
    };


    const columns = useMemo(
        () => [
            {
                accessorKey: 'id_saida_estoque',
                header: 'ID',
                size: 50,
            },


            {
                accessorFn: (row) => row.usuario_criador?.nome_amigavel || '',
                id: 'usuario',
                header: 'Usuário Criador',
                size: 130,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },



            {
                accessorFn: (row) => STATUS_TEXT[String(row.status)] || "Status não identificado",
                id: 'status',
                header: '📌',
                size: 50,
                filterFn: 'includesString',
                Cell: ({ row, renderedCellValue }) => {

                    const status = row.original.status;

                    var textoStatus;

                    if (status === 0) {
                        textoStatus = "Editando";
                    } else if (status === 1) {
                        textoStatus = "Aguardando Autorização";
                    } else if (status === 2) {
                        textoStatus = "Autorizado, Aguardando Baixa";
                    } else if (status === 3 || status === 4) {
                        textoStatus = "Baixado | Finalizado";
                    }

                    let icon;
                    switch (Number(status)) {
                        case 0: icon = <EditNoteIcon sx={{ color: 'gray' }} />; break;
                        case 1: icon = <HourglassTopIcon sx={{ color: 'orange' }} />; break;
                        case 2: icon = <TaskIcon sx={{ color: '#1976d2' }} />; break;
                        case 3: icon = <CheckCircleIcon sx={{ color: 'limegreen' }} />; break;

                        default: icon = null;
                    }

                    const customTooltip = (
                        <div
                            style={{
                                backgroundColor: themeHelper.paper,
                                width: 'auto',
                                maxWidth: 400,
                                color: themeHelper.text,
                                border: `1px solid ${themeHelper.border}`,
                                padding: 12,
                                fontSize: 16,
                                borderRadius: 8,
                                boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                            }}
                        >
                            {textoStatus || STATUS_TEXT[String(status)] || "Status não identificado"}
                        </div>
                    );

                    return (
                        <Tooltip title={customTooltip} arrow>
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    color: themeHelper.text,
                                    fontWeight: status === 2 ? 'bold' : 'normal'
                                }}
                            >
                                {icon}
                                {textoStatus || STATUS_TEXT[String(status)] || "Status não identificado"}
                            </span>
                        </Tooltip>
                    );
                },
            },



            {
                accessorKey: 'descricao',
                header: 'Descrição',
                size: 130,
            },


            {
                accessorKey: 'data_criacao',
                header: 'Data Criação',
                size: 130,
                Cell: ({ renderedCellValue }) => (
                    <span>{formatDate(renderedCellValue)}</span>
                ),
            },



        ],
        [],
    );



    const backgroundColorPage = 'white';

    return (
        <CoreThemeProvider theme={coreTheme}>
            <MuiThemeProvider theme={muiTheme}>
                <div style={{ backgroundColor: themeHelper.bg, minHeight: '100vh', color: themeHelper.text }}>
                    {/* Navegador */}
                    <NavegadorGestao
                        Almoxarifado={true}
                        OpSaida={true}
                        corFundo={darkMode ? '#1e1e1e' : 'white'}
                        travado={true}
                        corTexto={darkMode ? 'white' : 'black'}
                    />

                    <div style={{ padding: 10, width: '100%', height: '100%' }}>
                        {loading ? (
                            <Skeleton
                                animation="wave"
                                width={'100%'}
                                style={{ backgroundColor: themeHelper.primary }}
                            />
                        ) : (
                            <div>


                                <div
                                    style={{
                                        paddingTop: 1,
                                        height: 'calc(100vh - 95px)',
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    {objetos !== null && (
                                        <MaterialReactTable
                                            columns={columns}
                                            data={objetos}
                                            enableBottomToolbar={!isMobile}
                                            enableGlobalFilterModes
                                            enablePagination={!isMobile}
                                            enableRowActions
                                            renderTopToolbarCustomActions={() => (
                                                <Button style={{ margin: 5 }} variant="contained" color="primary" onClick={novo}>
                                                    Nova Saída Estoque
                                                </Button>
                                            )}
                                            paginationDisplayMode="pages"
                                            manualPagination={false}
                                            autoResetPageIndex={false}
                                            onPaginationChange={setPagination}
                                            rowCount={objetos.length}
                                            state={{ pagination }}
                                            getRowId={(row) => row.id_saida_estoque}
                                            enableGrouping
                                            initialState={{
                                                showGlobalFilter: true,
                                                showColumnFilters: !isMobile,
                                                columnVisibility: isMobile
                                                    ? {
                                                        id_saida_estoque: true,
                                                        status: true,
                                                        usuario: false,
                                                        descricao: false,
                                                        compra: false,
                                                        data_hora_conclusao: false,
                                                    }
                                                    : { nivel_prioridade: false },
                                            }}
                                            muiTableContainerProps={{
                                                sx: {
                                                    flex: 1,
                                                    overflowY: 'auto',
                                                    height: 'calc(100vh - 200px)',
                                                    maxHeight: 'calc(100vh - 200px)',
                                                    backgroundColor: themeHelper.bg,
                                                },
                                            }}
                                            enableStickyHeader={!isMobile}
                                            muiTableHeadCellProps={{
                                                sx: {
                                                    padding: '4px',
                                                    fontSize: '0.75rem',
                                                    lineHeight: 1,
                                                    height: '28px',
                                                    backgroundColor: themeHelper.tableHeadBg,
                                                    color: themeHelper.text,
                                                    borderBottom: `1px solid ${themeHelper.border}`,
                                                    display: isMobile ? 'none' : 'table-cell',
                                                },
                                            }}
                                            muiTableBodyCellProps={{
                                                sx: {
                                                    padding: '4px',
                                                    fontSize: '0.75rem',
                                                    lineHeight: 1.2,
                                                    color: themeHelper.text,
                                                    borderBottom: `1px solid ${themeHelper.border}`,
                                                },
                                            }}
                                            muiTableBodyRowProps={({ row }) => ({
                                                sx: {
                                                    height: '14px',
                                                    backgroundColor: row.index % 2 === 0 ? themeHelper.tableRowEven : themeHelper.tableRowOdd,
                                                    transition: 'background-color 0.3s',
                                                    '&:hover': {
                                                        backgroundColor: themeHelper.tableRowHover,
                                                    },
                                                },
                                            })}

                                            enableFullScreenToggle={!isMobile}
                                            renderRowActions={({ row }) => (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        gap: '1rem',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Tooltip title="Gerenciar">
                                                        <IconButton color="primary" onClick={() => handleClickEdicao(row.original)}>
                                                            <SettingsIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            )}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </MuiThemeProvider>
        </CoreThemeProvider>
    );

}



